import { TravelTime } from '@modules/ticket-fares-store/client/src';
import { TicketSelectorPanelProps } from '@modules/ticket-search/components/ticket-accordion-panel/ticketSelectorPanelProps.interface';
import { RadioGroupItemProps, RadioGroupProps } from '@nx-ng/types';
import { determineFareSelectorRadioOptions } from './format-option-common';

export const TRAVEL_TIME_LOOKUP: RadioGroupProps<string> = {
  groupName: 'time',
  standard: [
    {
      titleKey: 'travel_time_any_time',
      value: '1',
      subTitleKey: 'travel_time_any_time_description',
    },
    {
      titleKey: 'travel_time_pre_9_30',
      value: '2',
      subTitleKey: 'travel_time_pre_9_30_description',
    },
    {
      titleKey: 'travel_time_off_peak',
      value: '3',
      subTitleKey: 'travel_time_off_peak_description',
    },
  ],
};

export const buildTravelTimeOptions = (
  times: TravelTime[],
  selectedTime: string | undefined
): TicketSelectorPanelProps => {
  const travelTimeIds =
    times?.map((travelTime: TravelTime) => travelTime.id || '') || [];

  const items: RadioGroupProps<string> = determineFareSelectorRadioOptions({
    allOptions: TRAVEL_TIME_LOOKUP,
    validIds: travelTimeIds,
    selectedValue: selectedTime,
  });

  return {
    category: 'time',
    selectKey: 'label_select_travel_time',
    radio: items,
  };
};
